import React, { useRef, useState } from "react";
import { api } from "@/lib/api";
import { UploadCloud, FileText, X, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function FileUpload({ files, setFiles }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handleFiles = async (list) => {
    const arr = Array.from(list);
    setUploading(true);
    for (const f of arr) {
      const form = new FormData();
      form.append("file", f);
      try {
        const { data } = await api.post("/files/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
        setFiles((prev) => [...prev, data]);
      } catch (e) {
        toast.error(`Failed to upload ${f.name}`);
      }
    }
    setUploading(false);
  };

  const remove = (id) => setFiles((prev) => prev.filter((f) => f.file_id !== id));

  return (
    <div>
      <div
        data-testid="file-dropzone"
        onClick={() => inputRef.current?.click()}
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => { e.preventDefault(); handleFiles(e.dataTransfer.files); }}
        className="border-2 border-dashed border-border hover:border-brand transition-colors cursor-pointer p-8 text-center rounded-sm bg-secondary/40"
      >
        <input ref={inputRef} type="file" multiple hidden data-testid="file-input"
          onChange={(e) => handleFiles(e.target.files)}
          accept=".step,.stp,.stl,.iges,.igs,.sldprt,.dxf,.dwg,.pdf,.zip,.png,.jpg,.jpeg" />
        <div className="flex flex-col items-center gap-2">
          {uploading ? <Loader2 className="h-7 w-7 text-brand animate-spin" /> : <UploadCloud className="h-7 w-7 text-muted-foreground" />}
          <div className="text-sm font-medium">Drop CAD files or click to upload</div>
          <div className="text-xs font-mono text-muted-foreground">STEP · STL · IGES · DXF · PDF · ZIP</div>
        </div>
      </div>

      {files.length > 0 && (
        <ul className="mt-3 space-y-2" data-testid="uploaded-files-list">
          {files.map((f) => (
            <li key={f.file_id} className="flex items-center gap-3 border border-border px-3 py-2 rounded-sm bg-card">
              <FileText className="h-4 w-4 text-brand shrink-0" />
              <span className="text-sm truncate flex-1">{f.original_filename}</span>
              <span className="text-xs font-mono text-muted-foreground">{(f.size / 1024).toFixed(0)} KB</span>
              <button type="button" data-testid={`remove-file-${f.file_id}`} onClick={() => remove(f.file_id)} className="text-muted-foreground hover:text-destructive">
                <X className="h-4 w-4" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
